import { ClipboardCheckIcon, ClipboardCopyIcon } from '@heroicons/react/outline'
import { useState } from 'react'
import { getEncryptedLocalStorageData } from '../../lib/localStorage'
import { BaseModal } from './BaseModal'

type Props = {
    isOpen: boolean
    isCopied: boolean
    handleClose: () => void
    handleCopy: () => void
}

export const ExportModal = ({ isOpen, handleClose, isCopied, handleCopy }: Props) => {

    return (
        <BaseModal title="Your current game stats data" isOpen={isOpen} handleClose={handleClose}>
            <p className="text-sm font-bold text-gray-300 mb-2 mt-5">
                Copy your game stats and save it somewhere:
            </p>
            <div className="flex justify-center items-center">
                <p className="text-sm text-blue-500 truncate w-72">
                    {getEncryptedLocalStorageData()}
                </p>
                {
                    isCopied ? 
                    <ClipboardCheckIcon className="h-6 w-6 cursor-pointer stroke-white truncate" /> :
                    <ClipboardCopyIcon className="h-6 w-6 cursor-pointer stroke-white truncate animate-pulse duration-100" onClick={handleCopy}/> 
                }
            </div>
            <p className="text-sm font-bold text-gray-300 mb-5 mt-5">
                Recommend not to share this with anyone.
            </p>
        </BaseModal>
    )
}